import { Box, FormControl, FormLabel, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import { useCodeEditor } from "../../../hook/editor";
import { useProtocol, useProtocolLoad } from "../../../hook/protocol";
import { LoadBoundary } from "../../brand/LoadBoundary";
import { ProtocolBlock } from "../../../types/notebook/note/block/protocol";
import { Protocol } from "../../../types/protocol";
import { DynamicTextField } from "../../dynamicTextField";
import { CodeEditorProvider, CodeEditorCodeJson } from "../../editor";
import { NoteBlockContainer } from "../../note";
import { CopyClipboard } from "../../copyClipboard";

export const ProtocolBlockCodeTab: React.FC<{
  block: ProtocolBlock;
  protocol: Protocol | undefined;
}> = ({ block, protocol: proto }) => {
  const { setProtocol } = useProtocol(proto?.["protocol-id"]);
  const onSave = async (code: string) => {
    const newProtocol: Protocol = { ...proto!, spec: code };
    setProtocol(newProtocol);
  };
  const editorProps = {
    codeState: proto?.spec ?? "",
    onSaveCallback: onSave,
  };

  return (
    <CodeEditorProvider {...editorProps}>
      <CodeEditorCodeJson />
    </CodeEditorProvider>
  );
};

export const ProtocolBlockProtocol: React.FC<{
  block: ProtocolBlock;
}> = React.memo(({ block }) => {
  const protoId = block["protocol-id"];
  const { setProtocolName } = useProtocol(block["protocol-id"]);
  const { protocol, status, retry } = useProtocolLoad(block["protocol-id"]);
  const protocolName = protocol?.name ?? "";
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <NoteBlockContainer name="Protocol">
      <LoadBoundary
        status={status}
        onRetry={retry}
        label="Loading protocol"
        errorMessage="Could not load this protocol."
        testId="protocol-loading"
      >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography>{block["protocol-id"]}</Typography>
        <CopyClipboard value={block["protocol-id"]} />
      </Box>
      <FormControl>
        <FormLabel id={`protocol-${protoId}-name-field`}>
          Protocol Name
        </FormLabel>
        <DynamicTextField
          aria-labelledby={`protocol-${protoId}-name-field`}
          text={protocolName}
          setText={setProtocolName}
        />
      </FormControl>
      <Tabs value={selectedTab}>
        <Tab color="primary" label="Code" onClick={() => setSelectedTab(0)} />
      </Tabs>
      {selectedTab === 0 ? (
        <ProtocolBlockCodeTab block={block} protocol={protocol} />
      ) : (
        <></>
      )}
      </LoadBoundary>
    </NoteBlockContainer>
  );
});
